/**
 * Data Fetch
 */

// 特集
export function fetch_special() {
	// コンテンツを取得し、ページに表示する
	function fetchPosts() {
		fetch('https://www.uni-work.co.jp/d/wp-json/wp/v2/special?_embed&_fields=id,date,excerpt,title,link,_links.wp:featuredmedia,_embedded.wp:featuredmedia&per_page=4')
			.then(response => response.json())
			.then(data => {
				const container = document.querySelector('.c-special-items');
				if (!container) return;

				data.forEach(val => {
					const dateData = new Date(val.date);
					const year = dateData.getFullYear();
					const month = ("0" + (dateData.getMonth() + 1)).slice(-2);
					const day = ("0" + dateData.getDate()).slice(-2);
					const echoDate = `${year}.${month}.${day}`;

					let thum = "https://www.uni-work.co.jp/d/wp-content/themes/uni-work/assets/images/noimage.png"; // デフォルト画像
					if (val._embedded && val._embedded["wp:featuredmedia"]) {
						const media = val._embedded["wp:featuredmedia"][0];
						if (media && media.media_details && media.media_details.sizes && media.media_details.sizes.full) {
							thum = media.media_details.sizes.full.source_url;
						}
					}

					// 抜粋を10文字に制限し、超える場合は「...」を追加
					let excerptText = val.excerpt.rendered.replace(/<[^>]+>/g, ''); // HTMLタグを除去
					excerptText = excerptText.length > 20 ? excerptText.substring(0, 20) + '...' : excerptText;

					// HTML構造を生成してコンテナに追加
					container.insertAdjacentHTML('beforeend', `
						<div class="c-special-item">
							<a href="${val.link}">
								<figure>
									<img src="${thum}" alt="Thumbnail" width="300" height="200">
								</figure>
								<div class="title">${val.title.rendered}</div>
								<div class="excerpt">${excerptText}</div>
								<div class="date">${echoDate}</div>
							</a>
						</div>
					`);
				});
			})
			.catch(error => {
				console.error('Failed to fetch posts:', error);
			});
	}

	// ドキュメントの読み込みが完了したら実行
	document.addEventListener('DOMContentLoaded', fetchPosts);
}


// 事例
export function fetch_cases() {
	// コンテンツを取得し、ページに表示する
	function fetchPosts() {
		fetch('https://www.uni-work.co.jp/d/wp-json/wp/v2/cases?_embed&_fields=id,date,title,link,_links.wp:term,_links.wp:featuredmedia,_embedded.wp:featuredmedia&per_page=4')
			.then(response => response.json())
			.then(data => {
				const container = document.querySelector('.c-cases-items');
				if (!container) return;

				data.forEach(val => {
					const dateData = new Date(val.date);
					const year = dateData.getFullYear();
					const month = ("0" + (dateData.getMonth() + 1)).slice(-2);
					const day = ("0" + dateData.getDate()).slice(-2);
					const echoDate = `${year}.${month}.${day}`;

					let thum = "https://www.uni-work.co.jp/d/wp-content/themes/uni-work/assets/images/noimage.png"; // デフォルト画像
					if (val._embedded && val._embedded["wp:featuredmedia"]) {
						const media = val._embedded["wp:featuredmedia"][0];
						if (media && media.media_details && media.media_details.sizes && media.media_details.sizes.full) {
							thum = media.media_details.sizes.full.source_url;
						}
					}

					// カテゴリの取得
					let category = '';
					if (val._embedded['wp:term'] && val._embedded['wp:term'][0] && val._embedded['wp:term'][0].length > 0) {
						category = val._embedded['wp:term'][0].map(cat => `<span>${cat.name}</span>`).join(' ');
					}

					// タグの取得
					let tags = '';
					if (val._embedded['wp:term'] && val._embedded['wp:term'][1] && val._embedded['wp:term'][1].length > 0) {
						tags = val._embedded['wp:term'][1].map(tag => `<span>${tag.name}</span>`).join(' ');
					}

					// HTML構造を生成してコンテナに追加
					container.insertAdjacentHTML('beforeend', `
						<div class="c-cases-item">
							<a href="${val.link}">
								<figure>
									<img src="${thum}" alt="Thumbnail" width="300" height="200">
								</figure>
								<div class="category">${category}</div>
								<div class="title">${val.title.rendered}</div>
								<div class="tags">${tags}</div>
							</a>
						</div>
					`);
				});
			})
			.catch(error => {
				console.error('Failed to fetch posts:', error);
			});
	}

	// ドキュメントの読み込みが完了したら実行
	document.addEventListener('DOMContentLoaded', fetchPosts);
}


// メディア掲載
export function fetch_medias() {
	// コンテンツを取得し、ページに表示する
	function fetchPosts() {
		fetch('https://www.uni-work.co.jp/d/wp-json/wp/v2/medias?_embed&_fields=id,date,title,link,_links.wp:featuredmedia,_embedded.wp:featuredmedia&per_page=5')
			.then(response => response.json())
			.then(data => {
				const container = document.querySelector('.c-media-items');
				if (!container) return;

				data.forEach(val => {
					const dateData = new Date(val.date);
					const year = dateData.getFullYear();
					const month = ("0" + (dateData.getMonth() + 1)).slice(-2);
					const day = ("0" + dateData.getDate()).slice(-2);
					const echoDate = `${year}.${month}.${day}`;

					let thum = "https://www.uni-work.co.jp/d/wp-content/themes/uni-work/assets/images/noimage.png"; // デフォルト画像
					if (val._embedded && val._embedded["wp:featuredmedia"]) {
						const media = val._embedded["wp:featuredmedia"][0];
						if (media && media.media_details && media.media_details.sizes && media.media_details.sizes.full) {
							thum = media.media_details.sizes.full.source_url;
						}
					}

					// HTML構造を生成してコンテナに追加
					container.insertAdjacentHTML('beforeend', `
						<div class="c-media-item">
							<a href="${val.link}">
								<figure>
									<img src="${thum}" alt="${val.title.rendered}" width="300" height="200">
								</figure>
								<div class="title">${val.title.rendered}</div>
							</a>
						</div>
					`);
				});
			})
			.catch(error => {
				console.error('Failed to fetch posts:', error);
			});
	}

	// ドキュメントの読み込みが完了したら実行
	document.addEventListener('DOMContentLoaded', fetchPosts);
}


// お知らせ
export function fetch_info() {
	// コンテンツを取得し、ページに表示する
	function fetchPosts() {
		fetch('https://www.uni-work.co.jp/d/wp-json/wp/v2/info?_embed&_fields=id,date,title,link&per_page=5')
			.then(response => response.json())
			.then(data => {
				const container = document.querySelector('.c-info-items');
				if (!container) return;

				data.forEach(val => {
					const dateData = new Date(val.date);
					const year = dateData.getFullYear();
					const month = ("0" + (dateData.getMonth() + 1)).slice(-2);
					const day = ("0" + dateData.getDate()).slice(-2);
					const echoDate = `${year}.${month}.${day}`;

					// HTML構造を生成してコンテナに追加
					container.insertAdjacentHTML('beforeend', `
						<div class="c-info-item">
							<div class="date">${echoDate}</div>
							<div class="title"><a href="${val.link}">${val.title.rendered}</a></div>
						</div>
					`);
				});
			})
			.catch(error => {
				console.error('Failed to fetch posts:', error);
			});
	}

	// ドキュメントの読み込みが完了したら実行
	document.addEventListener('DOMContentLoaded', fetchPosts);
}
